import { render } from "./PaginationSimple.vue?vue&type=template&id=11ffdb62"
import script from "./PaginationSimple.vue?vue&type=script&lang=js"
export * from "./PaginationSimple.vue?vue&type=script&lang=js"

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PaginationSimple.vue"]])

export default __exports__